import React from "react";

function SizeTable() {
  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
      }}
    >
      <div
        className="tab-pane f_detail-tab-panel"
        id="sizes-tab-panel"
        role="tabpanel"
        aria-labelledby="sizes-tab"
        style={{ marginBottom: "20px" }}
      >
        <div className="offcanvas-body">
          <div
            className="product-detail-sizes tab-pane-container"
            style={{ fontSize: "14px" ,fontFamily:"Poppins"}}
          >
            <p
              className="h3 product-detail-description-title"
              style={{
                fontSize: "18px",
                marginBottom: "15px",
                fontWeight: "bold",
              }}
            >
              Size Table
            </p>
            <div
              className="product-detail-sizes-text"
              style={{ marginBottom: "20px", lineHeight: "1.5", color: "#555" }}
            >
              We provide a size recommendation guide to help you choose the
              perfect size. For added confidence, we also offer sending a free
              sample set directly to your home.
              <a
                href="../../sample-order.html"
                style={{ color: "#007bff", textDecoration: "underline" }}
              >
                free sample set sent
              </a>{" "}
              to your home.
            </div>
            <div className="about-container1">
              <h1
                className="about-title1"
                style={{
                  fontSize: "18px",
                }}
              >
                How to Measure Correctly
              </h1>
              <div className="measurement-guide1">
                <div className="guide-item1">
                  <h2
                    style={{
                      fontSize: "18px",
                    }}
                  >
                    {" "}
                    Chest
                  </h2>
                  <p
                    style={{
                      fontSize: "14px",
                    }}
                  >
                    Measure around the widest part of your torso, horizontally
                    with a tape measure.
                  </p>
                </div>
                <div className="guide-item1">
                  <h2
                    style={{
                      fontSize: "18px",
                    }}
                  >
                    {" "}
                    Waist
                  </h2>
                  <p
                    style={{
                      fontSize: "14px",
                    }}
                  >
                    Measure around the narrowest part of your waist.
                  </p>
                </div>
                <div className="guide-item1">
                  <h2
                    style={{
                      fontSize: "18px",
                    }}
                  >
                    {" "}
                    Hip
                  </h2>
                  <p
                    style={{
                      fontSize: "14px",
                    }}
                  >
                    Measure around the largest part of your hips for the most
                    accurate fit.
                  </p>
                </div>
              </div>
              <div
                className="call-to-action1"
                style={{
                  fontSize: "14px",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                  }}
                >
                  {" "}
                  Get the best fit for your football shirts USA today!
                </p>
              </div>
            </div>
            {/* <div className="sizes-content">
              <h3>
                <span style={{ fontSize: "20px", fontWeight: "500" }}>
                  Men's Size Tables
                </span>
              </h3>
              <div className="text" style={{ marginBottom: "20px" }}>
                <br />
                <table
                  className="table--men"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr style={{ backgroundColor: "#e9ecef" }}>
                      <th
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        Sizes in cm
                      </th>
                      <th
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        XS
                      </th>
                      <th
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        S
                      </th>
                      <th
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        M
                      </th>
                      <th
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        L
                      </th>
                      <th
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        XL
                      </th>
                      <th
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        2XL
                      </th>
                      <th
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        3XL
                      </th>
                      <th
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        4XL
                      </th>
                      <th
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        5XL
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        Chest
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        85 - 90
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        91 - 96
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        97 - 102
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        103 - 108
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        109 - 114
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        115 - 120
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        121 - 126
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        127 - 132
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        133 - 138
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        Waist
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        73 - 90
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        79 - 96
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        85 - 102
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        91 - 108
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        97 - 114
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        103 - 120
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        109 - 126
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        115 - 132
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        120 - 137
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        Body height
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        160 - 180
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        165 - 185
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        170 - 190
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        175 - 195
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        180 - 200
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        185 - 205
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        185 - 205
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        185 - 205
                      </td>
                      <td
                        style={{ padding: "10px", border: "1px solid #dee2e6" }}
                      >
                        185 - 205
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                className="text"
                style={{ lineHeight: "1.5", color: "#555" }}
              >
                <b style={{ letterSpacing: "0px", fontSize: "18px" }}>
                  How to Measure Correctly:
                </b>
                <br />
                Chest: Measure horizontally with the tape measure around the
                widest part of your torso.
                <br />
                Waist: Measure horizontally around the narrowest part of your
                waist.
                <br />
                Hip: Measure with the tape measure where the hip circumference
                is largest.
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SizeTable;
